export enum RecipientType {
    Phone = 0,
    Email = 1
}